"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
require("../../core");
const delay = (callback, wait, ...args) => {
    return window.setTimeout(callback, +wait || 0, ...args);
};
exports.delay = delay;
//# sourceMappingURL=delay.js.map